import { Skeleton } from '../../../common/skeleton/Skeleton';
import styles from './QrCodeLoader.module.scss';

export const QrCodeLoader = () => (
  <div className={styles['qrCode-loader-container']} data-testid={'qrCode-loader-container'}>
    <Skeleton height="100" width="200" borderRadius="8" />
  </div>
);
